export const list = (state) => state.ratings
export const byId = (state) => (id) => state.ratings.find(r => r.id == id)
export const selected = (state) => state.selected